import type { SessionDto } from '@/features/session/data/dto/session.dto.ts'

const getSessionAdIds = ({ state }: SessionDto): string[] => {
  const generations: unknown = state?.generations
  if (!Array.isArray(generations)) return []

  return generations.flatMap((generation: unknown) => {
    if (typeof generation !== 'object' || generation === null) return []
    const { ads } = generation as { ads?: unknown }
    return Array.isArray(ads)
      ? ads.filter((ad): ad is string => typeof ad === 'string')
      : []
  })
}

// Returns the requested ad (audioform id) only when it belongs to the session,
// otherwise falls back to the session's default audioform.
export const resolveSessionAudioformId = (
  sessionDto: SessionDto,
  requestedAdId?: string
): string | undefined => {
  if (
    requestedAdId &&
    (requestedAdId === sessionDto.audioformId ||
      getSessionAdIds(sessionDto).includes(requestedAdId))
  ) {
    return requestedAdId
  }

  return sessionDto.audioformId
}
